import { Component, OnInit, Output, EventEmitter,ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { SpraAmcvParams, SpraApprovalParams, SpraCsaRate, SpraAmcvTotalValue, SpraRentalAmcvModel, SpraRentalAmcvParams, NotionalCounterDetail, NotionalInput } from 'src/app/Models/ops';
import { GetSpraPriceParam, OpsProduct } from 'src/app/Models/product';
import { MasterService } from 'src/app/Services/master.service';
import { NotificationService } from 'src/app/Services/notification.service';
import { Utility } from 'src/app/Utilities/utility';
import { SpraNotionalInputComponent } from '../spra-notional-input/spra-notional-input.component';
import {Mutex, MutexInterface, Semaphore, SemaphoreInterface, withTimeout} from 'async-mutex';
import { TransactionService } from 'src/app/Services/transaction.service';
import { OpsPartSerachComponent } from '../ops-part-serach/ops-part-serach.component';
import { promise } from 'protractor';


@Component({
  selector: 'app-spra-amcv-rental',
  templateUrl: './spra-amcv-rental.component.html',
  styleUrls: ['./spra-amcv-rental.component.css']
})
export class SpraAmcvRentalComponent implements OnInit {
  @ViewChild(OpsPartSerachComponent) opsPartSerachComponent!: OpsPartSerachComponent;
  @Output("RecalculatePLDetail") RecalculatePLDetail: EventEmitter<any> = new EventEmitter(); 
  SpraRentalAmcvModel: SpraRentalAmcvModel;
  SpraApprovalParams: SpraApprovalParams;
  spraAmcvTotalValue: SpraAmcvTotalValue;
  SaleType: string;
  spraCSARate: Array<SpraCsaRate>;
  ProfitTag: boolean;
  ProductPriceIndexRunning:number=0;
  ProductPriceIndex:number=0;
  ProductCodes: any[] = [];
  AmcvFGProductParams: Array<OpsProduct>;
  utility: Utility;
  DistanceID: [];
  MachineLife:number;
  constructor(private _MasterService: MasterService,
    private cookieService: CookieService,
    private _TransactionService: TransactionService,
    private _NotificationService: NotificationService,
    private dialog: MatDialog
  ) {
    this.SpraRentalAmcvModel = new SpraRentalAmcvModel();
    this.SpraApprovalParams = new SpraApprovalParams();
    this.spraCSARate = new Array<SpraCsaRate>();
    this.spraAmcvTotalValue = new SpraAmcvTotalValue();
    this.AmcvFGProductParams = new Array<OpsProduct>();
    this.SaleType = "";
    this.utility = new Utility(this.cookieService);
    this.ProfitTag = false;
    this.DistanceID=[];
    this.MachineLife=0;
    

  }


  ngOnInit(): void {
  }





  EmclChange(_spraAmcvParams: SpraRentalAmcvParams) {
    this.SpraRentalAmcvModel.CounterDetail.forEach((item) => {
      if (item.CounterId == _spraAmcvParams.CounterId) {
        item.EMCL = _spraAmcvParams.EMCL;
        this.AutoBindColorCounterEmcl(item);

      }
    })




  }

  AutoBindColorCounterEmcl(spraRentalAmcvParams: SpraRentalAmcvParams) {
    if (spraRentalAmcvParams.EMCL != undefined && this.SpraRentalAmcvModel.MachineLife != undefined) {
      spraRentalAmcvParams.TotalCopy = (spraRentalAmcvParams.EMCL*spraRentalAmcvParams.Qty* this.SpraRentalAmcvModel.MachineLife)
      // if (spraRentalAmcvParams.CounterVal != undefined) {
      //   spraRentalAmcvParams.TotalCounterValue = (spraAmcvParams.TotalCopy * spraAmcvParams.CounterVal)
      // }
      this.CalculateA3CopyLoad();
    } else {
      spraRentalAmcvParams.TotalCopy = 0;
    }
  }



  CalculateA3CopyLoad(CounterId: number = 0) {

    this.SpraRentalAmcvModel.CounterDetail.filter(function (item: SpraRentalAmcvParams) {
      return ([3, 4].indexOf(item.CounterId) >= 0 && CounterId == 0) || (item.CounterId == CounterId)
    }).forEach((element: SpraRentalAmcvParams) => {

      element.IsA3RatioEntered = false;
      let A4Counter: number = 0;
      let A3CopyRatio: number = 0;
      let TechnicalId: number = (element.TechnicalId != undefined ? element.TechnicalId : 0)
      if (element.CounterId == 3 && this.SpraApprovalParams.BlackA3CopyRatio != undefined) {
        A4Counter = 1;
        A3CopyRatio = this.SpraApprovalParams.BlackA3CopyRatio;
      }
      else if (element.CounterId == 4 && this.SpraApprovalParams.ColorA3CopyRatio != undefined) {
        A4Counter = 2;
        A3CopyRatio = this.SpraApprovalParams.ColorA3CopyRatio;
      }

      if (A4Counter > 0 && A3CopyRatio > 0) {
        this.BindA3CopyLoad(element, element.CounterId, A4Counter, A3CopyRatio, TechnicalId);
      }

    });



    // });
  }



  BindA3CopyLoad(element: SpraRentalAmcvParams, A3Counter: number, A4Counter: number, BlackA3CopyRatio: number, TechnicalId: number) {
    let A4SpraAmcvParams: SpraRentalAmcvParams = new SpraRentalAmcvParams();
    if (element.CounterId == A3Counter) {
      A4SpraAmcvParams = this.SpraRentalAmcvModel.CounterDetail.filter(function (item: SpraRentalAmcvParams) {
        return item.CounterId == A4Counter && item.TechnicalId == TechnicalId
      })[0];
      if (A4SpraAmcvParams != undefined && this.SpraRentalAmcvModel.MachineLife != undefined
        && A4SpraAmcvParams.EMCL != undefined && BlackA3CopyRatio != undefined
      ) {
        element.EMCL = Math.ceil(A4SpraAmcvParams.EMCL * BlackA3CopyRatio / 100);
        element.TotalCopy = Math.ceil(element.EMCL*element.Qty * this.SpraRentalAmcvModel.MachineLife);
        element.IsA3RatioEntered = true;

      }

    }
  }


  MachineLifeChange() {
    this.SetLeaseType();
    this.SpraRentalAmcvModel.CounterDetail.forEach((element: SpraRentalAmcvParams) => {
      this.EmclChange(element);
    })
  }




  Validation(): boolean {
    if (this.SpraRentalAmcvModel.CounterDetail.length > 0 && !this.utility.CheckNumberRequired(this.SpraRentalAmcvModel.MachineLife)) {
      this._NotificationService.showError("Please enter Machine Life.", "Contract Datail");
      return false
    }


    if (this.SpraRentalAmcvModel.CounterDetail.length > 0 && !this.utility.CheckNumberRequired(this.SpraRentalAmcvModel.ContPeriod)) {
      this._NotificationService.showError("Please enter Contract Period.", "Contract Datail");
      return false
    }

    if (this.SpraRentalAmcvModel.CounterDetail.length > 0 && !this.utility.CheckNumberRequired(this.SpraRentalAmcvModel.LockInMonths)) {
      this._NotificationService.showError("Please enter Lock In Months.", "Contract Datail");
      return false
    }

    if (this.SpraRentalAmcvModel.CounterDetail.length > 0 && !this.utility.CheckNumberRequiredWithZero(this.SpraRentalAmcvModel.SecurityDeposite)) {
      this._NotificationService.showError("Please enter SecurityDeposite.", "Contract Datail");
      return false
    }

    if (this.SpraRentalAmcvModel.CounterDetail.length > 0 && !this.utility.CheckNumberRequired(this.SpraRentalAmcvModel.MonthlyRent)) {
      this._NotificationService.showError("Please enter Monthly Rent.", "Contract Datail");
      return false
    }


    let i: number = 0
    for (i; i < this.SpraRentalAmcvModel.CounterDetail.length; i++) {
      
      if (!this.utility.CheckNumberRequired(this.SpraRentalAmcvModel.CounterDetail[i].AgreedCSARate)) {
        this._NotificationService.showError("Please enter Agreed CSA rate of " + this.SpraRentalAmcvModel.CounterDetail[i].CounterDesc + " .", "Contract Datail");
        return false;
      }      
      if (!this.utility.CheckNumberRequiredWithZero(this.SpraRentalAmcvModel.CounterDetail[i].CustomerCommitmentCopy)) {
        this._NotificationService.showError("Please enter Customer commitment copy per month of " + this.SpraRentalAmcvModel.CounterDetail[i].CounterDesc + " .", "Contract Datail");
        return false;
      }

      
      if (!this.utility.CheckNumberRequiredWithZero(this.SpraRentalAmcvModel.CounterDetail[i].AgreedFreeCopy)) {
        this._NotificationService.showError("Please enter Agreed free copy per month of " + this.SpraRentalAmcvModel.CounterDetail[i].CounterDesc + " .", "Contract Datail");
        return false;
      }
      
      if (!this.utility.CheckNumberRequired(this.SpraRentalAmcvModel.CounterDetail[i].EMCL)) {
        this._NotificationService.showError("Please enter Estimated monthly copy load of " + this.SpraRentalAmcvModel.CounterDetail[i].CounterDesc + " .", "Contract Datail");
        return false;
      }

      // if (this.SpraRentalAmcvModel.CounterDetail[i].AgreedFreeCopy > this.SpraRentalAmcvModel.CounterDetail[i].EMCL) {
      //   this._NotificationService.showError("Agreed free copy can not be more then Estimated monthly copy load  of " + this.SpraRentalAmcvModel.CounterDetail[i].CounterDesc + " .", "Contract Datail");
      //   return false;
      // }

    }
    return true;

  }


  SetLeaseType() {
    if (
      this.utility.CheckNumberRequired(this.SpraRentalAmcvModel.LockInMonths)
      && this.utility.CheckNumberRequired(this.SpraRentalAmcvModel.MachineLife)
      && this.SpraRentalAmcvModel.LockInMonths >= this.SpraRentalAmcvModel.MachineLife
    ) {
      this.SpraRentalAmcvModel.LeaseType = "Finance Lease";
    } else {
      this.SpraRentalAmcvModel.LeaseType = "Operating Lease";
    }


  }


  CalculateTotalSaleValue() {
    let OrderRate: number = 0;
    let CSARate: SpraCsaRate;
  
    let index:number =0 ;
    // let Amcvindex:number =0 ;
    // let TotProdQty:number =0;
    let TotNumOFProd:number=0;
    // this.AmcvFGProductParams.forEach((item: OpsProduct)=>{
    //   TotProdQty=TotProdQty + item.pQty;
    // });

    TotNumOFProd=this.AmcvFGProductParams.length;
    this.ProductPriceIndex = TotNumOFProd * this.SpraRentalAmcvModel.CounterDetail.length* this.DistanceID.length;

    // to get St CSA rate and CSA cost rate -->> and calculate avg based on product and counters
    setTimeout(() => {
      this.CalCulateAVGRate();  
    }, 100);
      
  }

 CalculateSrvRevenue()
 {

  this.SpraRentalAmcvModel.FreeCopyValue = 0;
   this.SpraRentalAmcvModel.CounterDetail.forEach((element) => {     

      //*this.GetTotalFGQty() -->> by RAJAN SINGH ON 19 JULY 2021 -->> spra "S53/2122/11" NO SHARED BY MR. ANAND -- QUANTITY WAS NOT MULTIPLYING IN FREE COPY VALUE 
      //element.Qty added by rahul yadav on 13/07/2022 
      this.SpraRentalAmcvModel.FreeCopyValue = this.SpraRentalAmcvModel.FreeCopyValue + (element.AgreedFreeCopy * element.CSACostRate) *this.GetTotalFGQty();
  });
  this.RecalculatePLDetail.emit({"data":"FromAMCV"});
 }


 GetTotalFGQty(){
  //  console.log(this.AmcvFGProductParams);
  return this.AmcvFGProductParams.map(mt=> mt.Quantity).reduce((sum, current) => sum + current, 0);
 }

async CalCulateAVGRate(){
  
let SaleType:string = 'CSA';
  let dt:any[]=[];
  let index = 0;
  const mutex = new Mutex();

  // console.log(this.opsPartSerachComponent);
  // console.log(this.SpraRentalAmcvModel);
  await  Promise.all(this.SpraRentalAmcvModel.CounterDetail.map(async (product) => {  
    //  console.log(product);  
    product.StdCSARate  = 0;     
    product.CSACostRate = 0
    let Quantity = 0;

    await Promise.all(this.DistanceID.filter((D: any) => D.CounterId == product.CounterId).map(async (element: any,DistIndex:number) => {           
      // console.log(element)
      if (product.ProductID != undefined && element.DistanceID != undefined) {     
        // console.log(element);
        await mutex.runExclusive(async () => {
          await this._MasterService.GetSPRAPriceListData(element.ProductId, product.CounterId, SaleType, element.DistanceID).then(async (d): Promise<any> => {
            if (d) {
              // console.log(d);
              index = index+1;
              let data: any = JSON.parse(d.toString());
  
                product.StdCSARate += data.PriceList * element.Qty ;
                product.CSACostRate += data.BookingLanded * element.Qty;
                Quantity += element.Qty;

                // console.log(product.CSACostRate + ' += ' + data.BookingLanded + ' * ' + (item.Quantity < element.Qty ? item.Quantity : element.Qty));
            }
  
          });
        });
      }
    }));

    product.StdCSARate = parseFloat((product.StdCSARate / Quantity).toFixed(2));
    product.CSACostRate = parseFloat((product.CSACostRate / Quantity).toFixed(2));

    // console.log(product.Qty);
    if(product.AgreedCSARate!=undefined)
    {
      // changed by rajan singh on 23 june 2021 -->> as discussed with sharp, calculation should be based on landed and agreed rate
      // product.CSAGP= ((product.AgreedCSARate-product.StdCSARate)/product.AgreedCSARate) *100;
      product.CSAGP= ((product.AgreedCSARate-product.CSACostRate)/product.AgreedCSARate) *100;
    }

  }));

    
    this.CalculateSrvRevenue();      
      
  // }, 4000);
}

  RecalculateServiceRevenue()
  {
    if(this.ProfitTag){
    this.CalculateSrvRevenue();
    }
  }

ResetNotionalInput(){
  this.SpraRentalAmcvModel.MonthlyRent = 0;    
  this.SpraRentalAmcvModel.NotionalInput = new NotionalInput();
  this.SpraRentalAmcvModel.CounterDetail.forEach((cd) => {
    cd.CustomerCommitmentCopy = 0;
    cd.AgreedFreeCopy = 0;    
   });
}

chkNotionalClick(){  
  this.ResetNotionalInput()
  }

  EnterNotionalRentDetail(){
    let _NotionalInput:NotionalInput = new NotionalInput();  
    if(this.SpraRentalAmcvModel.NotionalInput != undefined && this.SpraRentalAmcvModel.NotionalInput.CounterDetail.length>0){
      _NotionalInput =  this.SpraRentalAmcvModel.NotionalInput;
    }else{
      
      _NotionalInput.CounterDetail = this.SpraRentalAmcvModel.CounterDetail.map((mc)=>{
            let _NotionalCounter:NotionalCounterDetail = new NotionalCounterDetail()
            _NotionalCounter.CounterId = mc.CounterId;
            _NotionalCounter.CounterDesc = mc.CounterDesc;
            return _NotionalCounter;
          })
  
    }
    
    const dialogRef = this.dialog.open(SpraNotionalInputComponent, {
      width: '100%',
      height:'50%',
      data: {_NotionalInput: _NotionalInput}
      
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.data != undefined) {
        this.SpraRentalAmcvModel.MonthlyRent = result.data.NotionalInput.Rent;
        this.SpraRentalAmcvModel.NotionalInput =  result.data.NotionalInput;
        this.CalculateRentFromNotionalRent();
        // let NotionalDiscount=0;
        // this.SpraRentalAmcvModel.CounterDetail.map((mc)=>{
        //   let _NotionalCounterDetail:NotionalCounterDetail = this.SpraRentalAmcvModel.NotionalInput.CounterDetail.filter(mnc=> {return mnc.CounterId == mc.CounterId})[0];
        //   mc.CustomerCommitmentCopy = _NotionalCounterDetail.Commitment;
        //   NotionalDiscount += (_NotionalCounterDetail.Commitment*mc.CSACostRate);
        // });
        
        // this.SpraRentalAmcvModel.MonthlyRent =Math.round(this.SpraRentalAmcvModel.MonthlyRent - NotionalDiscount);
      }
    });
  }


  CalculateRentFromNotionalRent(){    
    if(this.SpraRentalAmcvModel.NotionalInput.Rent != undefined && this.SpraRentalAmcvModel.NotionalInput.Rent>0){
    this.SpraRentalAmcvModel.MonthlyRent = this.SpraRentalAmcvModel.NotionalInput.Rent;
      let NotionalDiscount=0;
      this.SpraRentalAmcvModel.CounterDetail.map((mc)=>{
        let _NotionalCounterDetail:NotionalCounterDetail = this.SpraRentalAmcvModel.NotionalInput.CounterDetail.filter(mnc=> {return mnc.CounterId == mc.CounterId})[0];
        mc.CustomerCommitmentCopy = _NotionalCounterDetail.Commitment;
        NotionalDiscount += (_NotionalCounterDetail.Commitment*mc.CSACostRate);
      });
      
      this.SpraRentalAmcvModel.MonthlyRent =Math.round(this.SpraRentalAmcvModel.MonthlyRent - NotionalDiscount);
    }
  }

}

// export class Mutex {
//   private mutex = Promise.resolve();

//   lock(): PromiseLike<() => void> {
//     let begin: (unlock: () => void) => void = unlock => {};

//     this.mutex = this.mutex.then(() => {
//       return new Promise(begin);
//     });

//     return new Promise(res => {
//       begin = res;
//     });
//   }

//   async dispatch(fn: (() => T) | (() => PromiseLike<T>)): Promise<T> {
//     const unlock = await this.lock();
//     try {
//       return await Promise.resolve(fn());
//     } finally {
//       unlock();
//     }
//   }
// }